import {TranslationFunction} from "../../../../../store/localization/TranslMessasge";
import {GridColDef, GridValueFormatterParams} from "@mui/x-data-grid";
import {CommonTranslationKey} from "../../CommonTranslationKey";

export function createLabelsGridColDef(_transl: TranslationFunction): GridColDef[] {
    return [
        {field: 'name', headerName: _transl(CommonTranslationKey.TITLE), width: 300},
        {field: 'code', headerName: _transl(CommonTranslationKey.CODE), width: 150},
        {field: 'description', headerName: _transl(CommonTranslationKey.DESCRIPTION), width: 300},
        {
            field: 'publicLabel',
            headerName: _transl(CommonTranslationKey.PRIVATE),
            width: 150,
            valueFormatter: (params: GridValueFormatterParams) => {
                switch (params.value) {
                    case true:
                        return _transl(CommonTranslationKey.NO);
                    case false:
                        return _transl(CommonTranslationKey.YES);
                    default:
                        return "";
                }
            }
        },
        {field: 'user', headerName: _transl(CommonTranslationKey.USER), width: 150},
    ]
}
